// SMS deliverability analysis — mirrors the backend messaging.smart_encode so the composer
// can warn managers BEFORE they send. Carriers reject/limit messages that fall back to UCS-2
// (Twilio error 30019). UCS-2 is triggered by non-GSM-7 characters — usually typographic
// punctuation (em-dashes, curly quotes, ellipses) or emoji.

// GSM 03.38 default alphabet — each char sends as one 7-bit unit.
const GSM_BASIC =
  "@\u00a3$\u00a5\u00e8\u00e9\u00f9\u00ec\u00f2\u00c7\n\u00d8\u00f8\r\u00c5\u00e5\u0394_\u03a6\u0393\u039b\u03a9\u03a0\u03a8\u03a3\u0398\u039e\u001b\u00c6\u00e6\u00df\u00c9 !\"#\u00a4%&'()*+,-./0123456789:;<=>?\u00a1ABCDEFGHIJKLMNOPQRSTUVWXYZ\u00c4\u00d6\u00d1\u00dc\u00a7\u00bfabcdefghijklmnopqrstuvwxyz\u00e4\u00f6\u00f1\u00fc\u00e0";
// Extension chars — legal in GSM-7 but each takes TWO units.
const GSM_EXT = "^{}\\[~]|\u20ac";

// Unicode punctuation that has a plain GSM-7 lookalike (kept in sync with backend smart_encode).
const SMART_MAP = {
  "\u2018": "'", "\u2019": "'", "\u201A": "'", "\u201B": "'", "\u02BC": "'", "\u00B4": "'", "\u0060": "'",
  "\u201C": '"', "\u201D": '"', "\u201E": '"', "\u201F": '"', "\u00AB": '"', "\u00BB": '"',
  "\u2013": "-", "\u2014": "-", "\u2015": "-", "\u2212": "-",
  "\u2026": "...",
  "\u2022": "*", "\u00B7": "*", "\u2027": "*",
  "\u2039": "<", "\u203A": ">",
  "\u2044": "/",
  "\u00A0": " ", "\u2007": " ", "\u2009": " ", "\u202F": " ", "\u200A": " ",
  "\u2002": " ", "\u2003": " ", "\u2004": " ", "\u2005": " ", "\u2006": " ", "\u2008": " ",
  "\u200B": "", "\uFEFF": "", "\u200D": "", "\uFE0F": "", "\uFE0E": "",
};

// Friendly names so the warning reads like plain English.
const NICE = {
  "\u2014": "em-dash (\u2014)", "\u2013": "en-dash (\u2013)",
  "\u2019": "curly apostrophe (\u2019)", "\u2018": "curly quote (\u2018)",
  "\u201C": "curly quote (\u201C)", "\u201D": "curly quote (\u201D)",
  "\u2026": "ellipsis (\u2026)", "\u2022": "bullet (\u2022)",
  "\u00A0": "non-breaking space",
};

export function smartEncode(text) {
  if (!text) return text || "";
  let out = "";
  for (const ch of text) out += (SMART_MAP[ch] !== undefined ? SMART_MAP[ch] : ch);
  return out;
}

export function analyzeSms(text) {
  const t = text || "";
  const chars = [...t];
  let isUnicode = false;
  let gsmUnits = 0;
  const offenders = new Set();
  let hasCleanable = false;
  let emojiLeft = false;
  for (const ch of chars) {
    if (GSM_BASIC.indexOf(ch) !== -1) gsmUnits += 1;
    else if (GSM_EXT.indexOf(ch) !== -1) gsmUnits += 2;
    else {
      isUnicode = true;
      offenders.add(ch);
      if (SMART_MAP[ch] !== undefined) hasCleanable = true;
      else emojiLeft = true;
    }
  }
  const count = chars.length;
  let segments = 0;
  if (count > 0) {
    if (isUnicode) segments = count <= 70 ? 1 : Math.ceil(count / 67);
    else segments = gsmUnits <= 160 ? 1 : Math.ceil(gsmUnits / 153);
  }
  return {
    count,
    segments,
    isUnicode,
    offenders: [...offenders],
    offenderLabels: [...offenders].map((c) => NICE[c] || `"${c}"`),
    hasCleanable,
    emojiLeft,
    cleaned: smartEncode(t),
  };
}
